// extracted by mini-css-extract-plugin
export default {"selected-items-extras":"_1bQpU","selectedItemsExtras":"_1bQpU"};